import { RESET_CLAIM, SET_CLAIM } from './claim-actions';

export const setClaim = (data) => dispatch => {
    dispatch({
        type: SET_CLAIM,
        payload: { trackingNumber: null, ...data }
    });
};

export const resetClaim = (data) => dispatch => {
    dispatch({
        type: RESET_CLAIM
    });
};
